import { BaseEntityDto } from "@/core/common/entities/base-entity.dto";

export class ManufacturerDto extends BaseEntityDto {
  name: string;
}
